<template>
	<ListItem class="c-list-item-event" v-bind="$props">
		<template #footer>
			<ul
				v-if="details.location || details.time || details.price"
				class="
					flex
					<1024:flex-col
					gap-x-sm/h gap-y-4xs/v
					mt-xs/v
					text-label
				"
			>
				<li
					v-if="details.location && details.location.address"
					class="inline-flex items-center"
				>
					<SvgIconLocation
						class="
							w-16
							>=1024:w-21
							h-20
							>=1024:h-24
							mr-8
							>=1024:mr-12
						"
					/>
					<span
						v-text="
							[details.location.name, details.location.address]
								.filter(Boolean)
								.join(', ')
						"
					></span>
				</li>
				<li v-if="details.time" class="inline-flex items-center">
					<SvgIconClock
						class="
							w-16
							>=1024:w-21
							h-20
							>=1024:h-16
							mr-8
							>=1024:mr-12
						"
					/>
					<span v-text="details.time"></span>
				</li>
				<li v-if="details.price" class="inline-flex items-center">
					<SvgIconMoney
						class="
							w-16
							>=1024:w-21
							h-20
							>=1024:h-24
							mr-8
							>=1024:mr-12
						"
					/>
					<span v-text="details.price"></span>
				</li>
			</ul>
		</template>
	</ListItem>
</template>

<script>
import ListItem from '~/components/main/ListItem';
import { nuxtImgSizes } from '~/assets/js/utilities/helpers';
import SvgIconLocation from '~/assets/svgs/icon-location.svg?inline';
import SvgIconClock from '~/assets/svgs/icon-clock.svg?inline';
import SvgIconMoney from '~/assets/svgs/icon-money.svg?inline';

export default {
	name: 'ListItemEvent',

	components: {
		ListItem,
		SvgIconLocation,
		SvgIconClock,
		SvgIconMoney,
	},

	props: {
		...ListItem.props,

		// Explicitly used props
		details: {
			type: Object,
			default: () => ({}),
		},
	},

	computed: {},

	methods: {
		nuxtImgSizes,
	},
};
</script>
